var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcMenuItem = function SvgIcMenuItem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1877F2",
    d: "M15.78 4.5H5.22c-.948 0-1.72.56-1.72 1.25S4.272 7 5.22 7h10.56c.948 0 1.72-.56 1.72-1.25s-.772-1.25-1.72-1.25",
    opacity: 0.32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1877F2",
    d: "M18.78 10.75H8.22c-.948 0-1.72.56-1.72 1.25s.772 1.25 1.72 1.25h10.56c.948 0 1.72-.56 1.72-1.25s-.772-1.25-1.72-1.25M15.78 17H5.22c-.948 0-1.72.56-1.72 1.25s.772 1.25 1.72 1.25h10.56c.948 0 1.72-.56 1.72-1.25S16.728 17 15.78 17"
  })));
};
export default SvgIcMenuItem;